import {Stack} from '@primer/react'
import type {Diffstats} from '../types/diffstats'
import styles from './DiffStatText.module.css'

function buildScreenReaderHint({linesAdded, linesDeleted}: {linesAdded: number; linesDeleted: number}): string {
  let labelText = 'Lines changed: '
  labelText += `${linesAdded} ${linesAdded === 1 ? 'addition' : 'additions'} & `
  labelText += `${linesDeleted} ${linesDeleted === 1 ? 'deletion' : 'deletions'}`
  return labelText
}

export function DiffStatText({diffStat}: {diffStat?: Diffstats}) {
  if (!diffStat || (diffStat.lines_added === 0 && diffStat.lines_deleted === 0)) return null

  return (
    <Stack direction="horizontal" gap="condensed">
      <span aria-hidden="true" className={`${styles.diffstat} ${styles.added}`}>
        +{diffStat.lines_added.toLocaleString()}
      </span>
      <span aria-hidden="true" className={`${styles.diffstat} ${styles.deleted}`}>
        -{diffStat.lines_deleted.toLocaleString()}
      </span>
      <span className="sr-only">
        {buildScreenReaderHint({linesAdded: diffStat.lines_added, linesDeleted: diffStat.lines_deleted})}
      </span>
    </Stack>
  )
}

try{ DiffStatText.displayName ||= 'DiffStatText' } catch {}